export class SignatureViewModel {
    constructor(private createSignatureFromJson: (metadata: string) => void, public signatureId: number, public name: string, public metadata: string) {
    
    }

    click() {
        console.log("click");
        this.createSignatureFromJson(this.metadata);
    }
}


// WEBPACK FOOTER //
// ./code/SignatureViewModel.ts